import React from 'react';
import Dot from './Dot';

interface IStepperProps {
    defaultValue?: number;
    value?: number;
    numberSteps: number;
    onChange: (value: number) => void;
}

interface IStepperState {
    value: number;
}

export class Stepper extends React.PureComponent<IStepperProps, IStepperState> {
    /**
     * Mutable value is when the value changes should be driven by the state,
     * otherwise its by the property default
     */
    isMutableValue: boolean;

    constructor(props: IStepperProps) {
        super(props);
        const { defaultValue, value } = props;
        const statValue = value || defaultValue || 0;
        this.state = {
            value: statValue,
        };
        // this.isClearClicked = false;
        this.isMutableValue = !props.hasOwnProperty('value');

        if (!this.isMutableValue && props.onChange === undefined) {
            throw new Error(
                'You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange`'
            );
        }
    }

    /**
     * handleChangeValue function
     * @param {number} value The next value
     */
    handleChangeValue = (value: number) => {
        const { onChange } = this.props;
        const nextValues = value;

        if (!this.isMutableValue && onChange !== undefined) {
            onChange(nextValues);
        } else {
            this.setState({ value }, () => {
                if (onChange !== undefined) {
                    onChange(nextValues);
                }
            });
        }
    };

    render() {
        const { numberSteps } = this.props;
        const value = this.props.value !== undefined ? this.props.value : this.state.value;
        const dots = Array.from(Array(numberSteps).keys());

        return (
            <div style={{ display: 'flex' }}>
                {dots.map(val => (
                    <Dot
                        key={`stepper-$${val}`}
                        isSelected={val === value}
                        value={val}
                        onClick={this.handleChangeValue}
                    />
                ))}
            </div>
        );
    }
}

export default Stepper;
